import api from './api';

export const authService = {
    async login(email, password) {
        // FIX (FRONTEND-BUG-008): Use application/x-www-form-urlencoded per OAuth2 spec
        // OAuth2 password flow expects URL-encoded form data, not multipart
        const params = new URLSearchParams();
        params.append('username', email);
        params.append('password', password);

        const response = await api.post('/auth/login/', params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });

        if (response.data.access_token) {
            localStorage.setItem('jwt_token', response.data.access_token);
        }

        return response.data;
    },

    async register(username, email, password) {
        const response = await api.post('/auth/register/', {
            username,
            email,
            password,
        });
        return response.data;
    },

    async logout() {
        try {
            await api.post('/auth/logout/');
        } finally {
            localStorage.removeItem('jwt_token');
        }
    },

    async getCurrentUser() {
        const response = await api.get('/auth/me/');
        return response.data;
    },

    isAuthenticated() {
        return !!localStorage.getItem('jwt_token');
    },

    async updateProfile(username, email) {
        const response = await api.put('/auth/me/', {
            username,
            email,
        });
        return response.data;
    },

    async changePassword(currentPassword, newPassword) {
        const response = await api.put('/auth/password/', {
            current_password: currentPassword,
            new_password: newPassword,
        });
        return response.data;
    },

    async deleteAccount(password) {
        const response = await api.delete('/auth/account/', {
            data: { password },
        });
        return response.data;
    },
};
